// src/context/ThemeContext.js
import React, { createContext, useState, useEffect } from 'react';

import BlossomImg   from '../assets/images/Blossom.webp';
import VigorImg     from '../assets/images/Vigor.webp';
import TokiImg      from '../assets/images/Toki.webp';
import LullabieImg  from '../assets/images/Lullabie.webp';
import NovaImg      from '../assets/images/Nova.webp';

import MorningBG    from '../assets/images/Morning_BG.webp';
import NightBG    from '../assets/images/Night_BG.webp';
// (and your other backgrounds if you have them)

export const ThemeContext = createContext();

const themes = {
  Blossom: {
    name: 'Blossom',
    backgroundImage: MorningBG,
    img: BlossomImg,
    primaryColor: '#FFF7D6',     // background
    cardBg: '#FFF7D6',
    cardBorder: '#F9C74F',
    textColor: '#1e1e1e',
    textColor1: '#1e1e1e',
    popupBg: '#FFE59E',
    popupText: '#333',
    buttonGradient: 'linear-gradient(90deg, #f9c74f, #f48c06)',
    buttonText: '#fff',
    shortcutBg: '#FFE59E',
    shortcutBorder: '#FFD262',
    favoriteBg: '#FFE59E',
    favoriteBorder: '#F9C74F',
    shareColor: '#F9C74F',
  },
  Vigor: {
    name: 'Vigor',
    backgroundImage: MorningBG,
    img: VigorImg,
    primaryColor: '#FFF2E0',     // background
    cardBg: '#FFF2E0',
    cardBorder: '#f5b47e',
    textColor: '#1e1e1e',
    textColor1: '#1e1e1e',
    popupBg: '#FFD89E',
    popupText: '#333',
    buttonGradient: 'linear-gradient(90deg, #FFD262, #F9C74F)',
    buttonText: '#fff',
    shortcutBg: '#FFD89E',
    shortcutBorder: '#f5b47e',
    favoriteBg: '#FFD89E',
    favoriteBorder: '#f5b47e',
    shareColor: '#F48C06',
  },
  Toki: {
    name: 'Toki',
    backgroundImage: MorningBG,
    img: TokiImg,
    primaryColor: '#FFE6F7',     // background
    cardBg: '#FFE6F7',
    cardBorder: '#fbb6ce',
    textColor: '#1e1e1e',
    textColor1: '#1e1e1e',
    popupBg: '#FFD9F7',
    popupText: '#333',
    buttonGradient: 'linear-gradient(90deg, #FBC2EB, #fbb6ce)',
    buttonText: '#fff',
    shortcutBg: '#FFD9F7',
    shortcutBorder: '#fbb6ce',
    favoriteBg: '#FFD9F7',
    favoriteBorder: '#fbb6ce',
    shareColor: '#F17CB0',
  },
  Lullabie: {
    name: 'Lullabie',
    backgroundImage: NightBG,
    img: LullabieImg,
    primaryColor: '#E8F4FF',     // background
    cardBg: '#B2D2F3',
    cardBorder: '#4A80A8',
    textColor: '#fff',
    textColor1: '#1e1e1e',
    popupBg: '#4A80A8',
    popupText: '#fff',
    buttonGradient: 'linear-gradient(90deg, #2563eb, #38bdf8)',
    buttonText: '#fff',
    shortcutBg: '#B2D2F3',
    shortcutBorder: '#4A80A8',
    favoriteBg: 'linear-gradient(135deg, #17315c, #4A80A8)',
    favoriteBorder: '#17315c',
    shareColor: '#fff',
  },
  Nova:     { name: 'Nova',      backgroundImage: MorningBG, img: NovaImg, primaryColor: '#E8F4FF', textColor: '#1e1e1e'  },
};

const mascots = {
  Blossom:  { name: 'Blossom',  desc: 'Your gentle all-round support',     img: BlossomImg,  quote: '“You’re doing better than you think!”' },
  Vigor:    { name: 'Vigor',    desc: 'Your energizing buddy for movement', img: VigorImg,    quote: '“Keep moving forward!”' },
  Toki:     { name: 'Toki',     desc: 'Your focus friend for calm work',    img: TokiImg,     quote: '“Rest is not a reward, it’s a right.”' },
  Lullabie: { name: 'Lullabie', desc: 'Your guide to peaceful rest',       img: LullabieImg, quote: '“Every little thing adds a little light.”' },
  Nova:     { name: 'Nova',     desc: 'Your spark for curiosity & wonder',  img: NovaImg,     quote: '“Explore more, every single day.”' },
};
export const mascotData = mascots;

export function ThemeProvider({ children }) {
  // Single source of truth: the mascot/theme name
  const storedName = localStorage.getItem('selectedThemeName') || 'Blossom';
  const [selectedName, setSelectedName] = useState(storedName);

  // Keep localStorage & state in sync if changed elsewhere
  useEffect(() => {
    function handleStorage(e) {
      if (e.key === 'selectedThemeName' && themes[e.newValue]) {
        setSelectedName(e.newValue);
      }
    }
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  const changeTheme = (name) => {
    if (!themes[name]) return;
    localStorage.setItem('selectedThemeName', name);
    setSelectedName(name);
  };

  // Derive theme & mascot from the same selectedName
  const selectedTheme  = themes[selectedName];
  const selectedMascot = mascots[selectedName];

  return (
    <ThemeContext.Provider value={{
      selectedName,
      selectedTheme,
      selectedMascot,
      changeTheme
    }}>
      {children}
    </ThemeContext.Provider>
  );
}
